<template>
  <div class="home ">
    <SkeletonList />
  </div>
</template>

<script>
// @ is an alias to /src
import SkeletonList from '@/components/Skeleton/SkeletonList.vue'

export default {
  name: 'Home',
  components: {
    SkeletonList
  }
}
</script>
